import styled from 'styled-components';

const StyledSidebarDiv = styled.ul`
  // position: absolute;
  left: 0;
  top: 0;
  width: 250px;
  height: 700px;
  box-sizing: border-box;
  padding: 15px;
  background-color: #ededed;
  box-shadow: 0px 5px 22px 4px rgba(0,0,0,0.18);
  border-radius: 5px;
`;

export default StyledSidebarDiv;